export const searchPageSize = 6;
export const revalidateTimeout = 600;
export const homeTitle = "Home";
export const unitLimitQuantity = 10;
export const unitLimitTag = "unit-limit";
export const unitLimitQuery = `tag:${unitLimitTag}`;